import { useAppNavigation } from "@/features/Navigation/hooks/useAppNavigation";
import { Spinner } from "@chakra-ui/react";
import { useEffect } from "react";
import { useRedirectToCheckout } from "../hooks/useRedirectToCheckout";
import { useProducts } from "@/features/Subscriptions/hooks/useProducts";
import { useSubscription } from "@/features/Subscriptions/hooks/useSubscription";

/**
 * When a user navigates to this page, they will be redirected to the checkout page to purchase the pro plan.
 * If they don't have it.
 *
 * @returns
 */
export const CheckoutRedirect = () => {
  const { data: subscription } = useSubscription();
  const { data: products, isLoading } = useProducts();
  const { navigateToHome } = useAppNavigation();
  const redirectToCheckout = useRedirectToCheckout();

  const proSubscription = products?.find((product) => product.subscription_type === "pro");
  const monthlyProPrice = proSubscription?.prices?.find((price) => price.interval === "monthly");
  const hasProSubscription = subscription?.type === "pro";

  useEffect(() => {
    if (isLoading) return;

    if (hasProSubscription) {
      navigateToHome();
    }

    if (!hasProSubscription && monthlyProPrice) {
      redirectToCheckout(
        [
          {
            price: monthlyProPrice.price_id,
            quantity: 1,
          },
        ],
        true,
      );
    }
  }, [hasProSubscription, monthlyProPrice, isLoading]);

  return <Spinner />;
};
